import { useCustomToast } from '@elkaso-app/web-design';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import axios from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';

type TData = Record<string, any>;
type TError = AxiosError;
type TQueryKey = string[];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetDownloadImageApi(images: any, options?: Options): ReturnType {
  const isLoggedIn = useIsLoggedIn();
  const toast = useCustomToast();

  const queryFn = async () => {
    try {
      const downloadImage: Record<string, any> = {};

      await Promise.all(
        Object.keys(images)?.map(async (image) => {
          const { data } = await axios.get(images[image], {
            responseType: 'blob',
          });

          downloadImage[image] = data;
        })
      );

      return downloadImage;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useQueryWrapper([images], queryFn, {
    enabled: isLoggedIn,
    ...options,
  });
}
